<div class="p-3" *ngIf="helpTextView$ | async as helpTextView">
    <h3>{{helpTextView.title}}</h3>
    <h4 class="author" *ngIf="helpTextView.displayAuthor">{{helpTextView.author}}</h4>
    <mat-dialog-content class="p-0">
        <div class="ql-snow">
            <div class="ql-editor ql-editor-readonly px-0" [innerHTML]="helpTextView?.description | safeHtml"></div>
        </div>
    </mat-dialog-content>
    <div class="d-flex justify-content-end mt-2">
        <button type="button" 
                mat-flat-button 
                color="primary"
                (click)="close()"
        >
            {{ 'Common.Close' | translate }}
        </button>
    </div>
</div>
